import { getTemperature } from '../../../../helper/temperature';

export function P0003601SeuilTemperatureHorsGel() {
  let r = [];

  for (let i = -3; i <= 3; i++) {
    r.push({
      ref: i,
      label: getTemperature(i, 0),
    });
  }

  return r;
}
